// extracted by mini-css-extract-plugin
export default {"wrapper":"modal_wrapper__Cswmg","darken":"modal_darken__FqPqA","content":"modal_content__psGzk"};